/*
    Danger!
    You should not remove any comments from this file, if comments will be removed generator will be broken
*/

import Vue from 'vue'
import Vuex from 'vuex'

import AuthModule from '@/store/modules/Auth.module'
import FileModule from '@/store/modules/File.module'
import ModalModule from '@/store/modules/Modal.module'
import NotificationModule from '@/store/modules/Notification.module'
import ProfileModule from '@/store/modules/Profile.module'
import SettingModule from '@/store/modules/Setting.module'

// Generated modules imported under this 2 comments. DO NOT REMOVE ANY COMMENTS
// __generator_imports__
import RetargetingAudienceModule from '@/store/modules/RetargetingAudience.module'
import RetargetingAttributionModule from '@/store/modules/RetargetingAttribution.module'
import PartnerCategoriesModule from '@/store/modules/PartnerCategories.module'
import LinksGeneratorWorkflowModule from '@/store/modules/LinksGeneratorWorkflow.module'
import GeneratedLinksModule from '@/store/modules/GeneratedLinks.module'
import BudgetRequestsLogModule from '@/store/modules/BudgetRequestsLog.module'
import AdvertisersCostModule from '@/store/modules/AdvertisersCost.module'
import AdvertisersModule from '@/store/modules/Advertisers.module'
import BudgetPlannerModule from '@/store/modules/BudgetPlanner.module'
import BudgetPlanModule from '@/store/modules/BudgetPlan.module'
import ClicksModule from '@/store/modules/Clicks.module'
import CohortAnalysisCumulativeModule from '@/store/modules/CohortAnalysisCumulative.module'
import CohortAnalysisModule from '@/store/modules/CohortAnalysis.module'
import CostsReportModule from '@/store/modules/CostsReport.module'
import CountryModule from '@/store/modules/Country.module'
import CpaRsPerformanceReportModule from '@/store/modules/CpaRsPerformanceReport.module'
import CurrenciesModule from '@/store/modules/Currencies.module'
import DashboardModule from '@/store/modules/Dashboard.module'
import EventsModule from '@/store/modules/Events.module'
import GeneralReportModule from '@/store/modules/GeneralReport.module'
import LandingsModule from '@/store/modules/Landings.module'
import NewStreamsModule from '@/store/modules/NewStreams.module'
import OfferModule from '@/store/modules/Offer.module'
import OfferPartnerTagsModule from '@/store/modules/OfferPartnerTags.module'
import OfferPartnersModule from '@/store/modules/OfferPartners.module'
import PartnerAffiliateModule from '@/store/modules/PartnerAffiliate.module'
import PartnerGroupsModule from '@/store/modules/PartnerGroups.module'
import PartnerInfoModule from '@/store/modules/PartnerInfo.module'
import PartnerReportModule from '@/store/modules/PartnerReport.module'
import PartnerTagsModule from '@/store/modules/PartnerTags.module'
import PartnersModule from '@/store/modules/Partners.module'
import PartnersSpendsModule from '@/store/modules/PartnersSpends.module'
import PaymentInvoicesModule from '@/store/modules/PaymentInvoices.module'
import SoloPaymentInvoicesModule from '@/store/modules/SoloPaymentInvoices.module'
import PaymentModelsModule from '@/store/modules/PaymentModels.module'
import PermissionModule from '@/store/modules/Permission.module'
import PlayerModule from '@/store/modules/Player.module'
import PlayersModule from '@/store/modules/Players.module'
import PlayersReportsModule from '@/store/modules/PlayersReports.module'
import PostbacksModule from '@/store/modules/Postbacks.module'
import ProductsModule from '@/store/modules/Products.module'
import ReportNotificationModule from '@/store/modules/ReportNotification.module'
import RolesModule from '@/store/modules/Roles.module'
import SpendsParsingLogModule from '@/store/modules/SpendsParsingLog.module'
import TrafficSourcesModule from '@/store/modules/TrafficSources.module'
import UsersModule from '@/store/modules/Users.module'
import PartnerRiskLevelModule from '@/store/modules/PartnerRiskLevel.module'
import EntityLogModule from '@/store/modules/EntityLog.module'
import PartnerSpendLogModule from '@/store/modules/PartnerSpendLog.module'
import SpendCountryReplacementRuleModule from '@/store/modules/SpendCountryReplacementRule.module'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    // Generated modules under this comment. DO NOT REMOVE ANY COMMENTS
    // __imported_entities__
    RetargetingAudienceModule,
    RetargetingAttributionModule,
    PartnerCategoriesModule,
    LinksGeneratorWorkflowModule,
    GeneratedLinksModule,
    BudgetRequestsLogModule,
    AdvertisersCostModule,
    AdvertisersModule,
    AuthModule,
    BudgetPlannerModule,
    BudgetPlanModule,
    ClicksModule,
    CohortAnalysisCumulativeModule,
    CohortAnalysisModule,
    CostsReportModule,
    CountryModule,
    CpaRsPerformanceReportModule,
    CurrenciesModule,
    DashboardModule,
    EventsModule,
    FileModule,
    GeneralReportModule,
    LandingsModule,
    ModalModule,
    NewStreamsModule,
    NotificationModule,
    OfferModule,
    OfferPartnerTagsModule,
    OfferPartnersModule,
    PartnerAffiliateModule,
    PartnerRiskLevelModule,
    PartnerGroupsModule,
    PartnerInfoModule,
    PartnerReportModule,
    PartnerTagsModule,
    PartnersModule,
    PartnersSpendsModule,
    PaymentInvoicesModule,
    SoloPaymentInvoicesModule,
    PaymentModelsModule,
    PermissionModule,
    PlayerModule,
    PlayersModule,
    PlayersReportsModule,
    PostbacksModule,
    ProductsModule,
    ProfileModule,
    ReportNotificationModule,
    RolesModule,
    SettingModule,
    SpendsParsingLogModule,
    TrafficSourcesModule,
    UsersModule,
    EntityLogModule,
    PartnerSpendLogModule,
    SpendCountryReplacementRuleModule,
  },
})
